import React, { useState } from "react";
import LoadingButton from "../../dumb/LoadingButton";
import useModal from "../../../hook/useModal";
import DisplayError from "../../dumb/DisplayError";
import useStatusThunk from "../../../hook/useStatusThunk";
import MemorySelect from "../projectManager/MemorySelect";
import { assignMemoryToProject, assignMemoryToTitle } from "../../../redux/ducks/memory";

const AssignMemoryToTitle = props => {
    const [show, hide, renderModal] = useModal();
    const [d_assignMemoryToTitle, t_status, t_error, t_event] = useStatusThunk(assignMemoryToTitle);
    const [d_assignMemoryToProject, p_status, p_error, p_event] = useStatusThunk(assignMemoryToProject);

    const [selectedMemoryID, setSelectedMemoryID] = useState();

    const onSuccess = () => {
        hide();
        setSelectedMemoryID(null);
    }

    t_event.onSuccess = onSuccess;
    p_event.onSuccess = onSuccess;

    const assign = () => {
        if (props.titleID != undefined) {
            d_assignMemoryToTitle({ memoryID: selectedMemoryID, titleID: props.titleID });
        } else if (props.projectID != undefined) {
            d_assignMemoryToProject({ memoryID: selectedMemoryID, projectID: props.projectID });
        }
    }

    return (
        <React.Fragment>
            <button className={"button button--memory " + props.className} onClick={show}>Assign Memory</button>

            {renderModal(
                <React.Fragment>
                    <div className="group">
                        <div className="label">Memory Name</div>
                        <MemorySelect onChange={e => setSelectedMemoryID(e.target.value)} />
                    </div>

                    <div className="group">
                        <DisplayError error={t_error} />
                    </div>

                    <div className="group">
                        <DisplayError error={p_error} />
                    </div>

                    <LoadingButton loading={t_status == "pending" || p_status == "pending"} className="button--memory" onClick={assign}>Assign Memory</LoadingButton>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default AssignMemoryToTitle;